export default __webpack_public_path__ + "2cced269e7de8c853e2e40f7d6c6e37c.svg";